<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<div class="folder-wrapper">
    <div class="left-wrapper">
      <div class="data-deceptions-row deception-title">
          <span class="setting-label">
              {{'DATA_DECEPTIONS' | translate}}
          </span>
          <div style="font-size: 0.8em; font-weight: normal;margin-top: 8px;">
              {{'DATA_DECEPTIONS_DESCRIPTION' | translate}}
          </div>
      </div>
      <div class="add-folder-btn">
          <button mat-raised-button id="add-folder-button" color="primary" (keyup.enter)="onAddFolderClick()"
                   (click)="onAddFolderClick()" aria-label="Add a deception file.">
              <i class="mdi mdi-plus-box-outline"></i>
              <span>{{'ADD_DECEPTION_FILE' | translate}}</span>
          </button>
      </div>
      <form [formGroup]="folderFormGroup">
          <div formArrayName="folders" *ngFor="let control of controls; let i = index;" class="folder-row-wrapper">
            <div class="data-deceptions-row" [formGroupName]="i" matRipple [matRippleDisabled]="true">
                <div *ngIf="show_environment_variables" class="add-env-var-icon">
                    <button id="env-var-{{i}}" color="accent" [matMenuTriggerFor]="menu" mat-icon-button [disableRipple]="true" matTooltip="{{'ADD_ENV_VAR' | translate}}"
                            matTooltipShowDelay="350" matTooltipPosition="right" aria-label="Add environment variable.">
                        <span class="mdi mdi-dots-horizontal"></span>
                    </button>
                    <mat-menu id="env-var-menu-{{i}}" #menu="matMenu">
                        <button id="homeEnvButton-{{i}}" mat-menu-item (click)="onAddVariable(control, i, '${HOME}\\')" matTooltip="C:\Users\<username>" matTooltipShowDelay="500" matTooltipPosition="right">
                            ${{'{'}}HOME{{'}'}}
                        </button>
                        <button id="appDataEnvButton-{{i}}" mat-menu-item (click)="onAddVariable(control, i, '${APPDATA}\\')" matTooltip="C:\Users\<username>\AppData\Roaming" matTooltipShowDelay="500" matTooltipPosition="right">
                            ${{'{'}}APPDATA{{'}'}}
                        </button>
                        <button id="allUserEnvButton-{{i}}" mat-menu-item (click)="onAddVariable(control, i, '${ALLUSERSPROFILE}\\')" matTooltip="C:\ProgramData" matTooltipShowDelay="500" matTooltipPosition="right">
                            ${{'{'}}ALLUSERSPROFILE{{'}'}}
                        </button>
                        <button id="systemRootEnvButton-{{i}}" mat-menu-item (click)="onAddVariable(control, i, '${SystemRoot}\\')" matTooltip="C:\Windows" matTooltipShowDelay="500" matTooltipPosition="right">
                            ${{'{'}}SystemRoot{{'}'}}
                        </button>
                        <button id="userEnvButton-{{i}}" mat-menu-item (click)="onAddVariable(control, i, '${USERPROFILE}\\')" matTooltip="C:\Users\<username>" matTooltipShowDelay="500" matTooltipPosition="right">
                            ${{'{'}}USERPROFILE{{'}'}}
                        </button>
                      </mat-menu>
                </div>
                <div class="policy-path-form-field" >
                    <mat-form-field appearance="outline">
                        <input matInput type="text" autocomplete="off" id="folder-path-{{i}}" class="folder-label" #folderPathInputs
                               [ngClass]="{'input-error': hasFolderError(i)}"
                               (focusin)="onFocusIn($event, i)"
                               (focusout)="onFocusOut($event, i)"
                               (input)="onInputChange($event, control, i)"
                               formControlName="path"
                               placeholder="{{'DECEPTION_INPUT_PLACEHOLDER' | translate}}"/>
                    </mat-form-field>
                    <div *ngIf="hasFolderError(i)" style="margin: -23px 0 0 10px; color: var(--warn-color);font-size: 12px;">{{deceptionFileErrors[i]}}</div>
                </div>
                <div class="remove-row-icon">
                    <button mat-icon-button (click)="removePathRow(control.value.path, i)" matTooltip="{{'REMOVE_DECEPTION_TOOLTIP' | translate}}"
                            matTooltipShowDelay="350" matTooltipPosition="right" aria-label="Remove deception file path.">
                        <span class="mdi mdi-close-circle-outline"></span>
                    </button>
                </div>
            </div>
          </div>
      </form>
    </div>
    <div class="button-col" tabindex="0">
        <button mat-stroked-button color="primary" class="set-recommend-button" (click)="onSetRecommendedClick()">
            {{'RECOMMENDED_BUTTON' | translate}}
        </button>
    </div>
</div>

